import { NewsCategory } from '../../types/news';

export const categoryAccent: Record<
  NewsCategory,
  { border: string; bg: string; text: string; dot: string }
> = {
  'Platform Updates': {
    border: 'border-pink-400/40',
    bg: 'bg-pink-500/10',
    text: 'text-pink-200',
    dot: 'bg-pink-400',
  },
  Industry: {
    border: 'border-purple-400/40',
    bg: 'bg-purple-500/10',
    text: 'text-purple-200',
    dot: 'bg-purple-400',
  },
  Regulation: {
    border: 'border-amber-400/40',
    bg: 'bg-amber-500/10',
    text: 'text-amber-200',
    dot: 'bg-amber-400',
  },
  'Product Launch': {
    border: 'border-cyan-400/40',
    bg: 'bg-cyan-500/10',
    text: 'text-cyan-200',
    dot: 'bg-cyan-400',
  },
  Trends: {
    border: 'border-fuchsia-400/40',
    bg: 'bg-fuchsia-500/10',
    text: 'text-fuchsia-200',
    dot: 'bg-fuchsia-400',
  },
};

export type MasonryVariant = 'featured' | 'wide' | 'default';

export function getMasonryVariant(index: number): MasonryVariant {
  const pattern: MasonryVariant[] = ['featured', 'default', 'default', 'wide', 'default', 'default'];
  return pattern[index % pattern.length];
}

export const categoryShortLabel: Record<NewsCategory, string> = {
  'Platform Updates': 'Platforms',
  Industry: 'Industry',
  Regulation: 'Policy',
  'Product Launch': 'Launches',
  Trends: 'Trends',
};
